module.exports = __webpack_public_path__ + "static/media/starbugs.e3a5d590.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/starbugs.jpg
// module id = 839
// module chunks = 6